import React, { ReactNode } from 'react';
import { Link } from '@fiverr-private/typography';
import { SectionContext } from '../../App';
import { trackButtonClick, trackLinkClick } from '../gtmTracking';

interface ExternalLinkProps {
  clickText?: string;
  category?: string;
  href: string;
  children: ReactNode;
  variant?: 'footer' | 'header' | 'subitem';
  type?: 'button' | 'link';
}

export const ExternalLink = ({ href, children, type = 'link', clickText, category, variant }: ExternalLinkProps) => {
  const { section } = React.useContext(SectionContext);

  const linkClick = () => {
    trackLinkClick({
      navigation: {
        id: `${section}Nav`,
        type: 'navigation',
        category,
      },
      clickUrl: href,
    });
  };

  const buttonClick = () => {
    trackButtonClick({
      sectionType: section,
      clickUrl: href,
      clickText,
    });
  };

  const onClick = type === 'button' ? buttonClick : linkClick;
  if (variant === 'subitem') {
    return (
      <Link
        href={href}
        target="_blank"
        rel="noreferrer"
        onClick={onClick}
        decoration="none"
        color={{ default: 'grey_900', hover: 'green_700' }}
        paddingY="2"
        paddingX="0"
      >
        {children}
      </Link>
    );
  }
  if (variant === 'footer') {
    return (
      <Link
        href={href}
        target="_blank"
        rel="noreferrer"
        onClick={onClick}
        decoration={{ default: 'none', hover: 'underline' }}
        color="grey_900"
      >
        {children}
      </Link>
    );
  }
  return (
    <Link
      href={href}
      target="_blank"
      rel="noreferrer"
      onClick={onClick}
      fontWeight="semibold"
      decoration="none"
      color={{ default: 'grey_900', hover: 'green_700' }}
    >
      {children}
    </Link>
  );
};
